import script from "./FlyingTiger-SyncStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyingTiger-SyncStatus.vue?vue&type=script&setup=true&lang=js"

import "./FlyingTiger-SyncStatus.vue?vue&type=style&index=0&id=000772e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-000772e2"]])

export default __exports__